module.exports = __webpack_public_path__ + "static/media/m1.499926a0.jpg";